/* rrd-fbt.js v7 */
(function () {
  'use strict';
  var wrap = document.getElementById('rrd-fbt');
  if (!wrap) return;

  var cards    = Array.from(wrap.querySelectorAll('[data-fbt-card]'));
  var mainCard = wrap.querySelector('[data-fbt-main]');
  var countEl  = document.getElementById('rrd-fbt-count');
  var totalEl  = document.getElementById('rrd-fbt-total');
  var btn      = document.getElementById('rrd-fbt-btn');
  var errEl    = document.getElementById('rrd-fbt-err');

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  function cardPrice(card) {
    var sel = card.querySelector('[data-fbt-select]');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      return opt ? (parseInt(opt.dataset.price, 10) || 0) : 0;
    }
    return parseInt(card.dataset.price, 10) || 0;
  }

  function recalc() {
    var total = 0, count = 0;
    cards.forEach(function (c) {
      if (!c.classList.contains('is-checked')) return;
      if (c.dataset.available === 'false') return;
      total += cardPrice(c);
      count++;
    });
    countEl.textContent = count === 1 ? '1 item selected' : count + ' items selected';
    totalEl.textContent = money(total);
    btn.disabled = count === 0;
  }

  /* sync main card variant from page */
  if (mainCard) {
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) mainCard.dataset.variantId = urlVariant;

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        mainCard.dataset.variantId = e.detail.variant.id;
        mainCard.dataset.price     = e.detail.variant.price;
        recalc();
      }
    });
    var pForm = document.querySelector('form[action="/cart/add"]');
    if (pForm) {
      var vInput = pForm.querySelector('input[name="id"], select[name="id"]');
      if (vInput) vInput.addEventListener('change', function () {
        mainCard.dataset.variantId = vInput.value;
        recalc();
      });
    }
  }

  cards.forEach(function (card) {
    if (card.dataset.available === 'false') return;
    card.addEventListener('click', function (e) {
      /* don't toggle when clicking the variant select or the ↗ view link */
      if (e.target.closest('[data-fbt-select]')) return;
      if (e.target.closest('.rrd-fbt__view-link')) return;
      card.classList.toggle('is-checked');
      if (card.hasAttribute('data-fbt-main')) {
        var lbl = card.querySelector('.rrd-fbt__toggle-label');
        if (lbl) lbl.textContent = card.classList.contains('is-checked') ? 'Included' : 'Not included';
      }
      recalc();
    });
    var sel = card.querySelector('[data-fbt-select]');
    if (sel) sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (opt) card.dataset.price = opt.dataset.price;
      recalc();
    });
  });

  btn.addEventListener('click', function () {
    var items = [];
    cards.forEach(function (c) {
      if (!c.classList.contains('is-checked')) return;
      if (c.dataset.available === 'false') return;
      var sel = c.querySelector('[data-fbt-select]');
      var id  = sel ? parseInt(sel.value, 10) : parseInt(c.dataset.variantId, 10);
      if (id) items.push({ id: id, quantity: 1 });
    });
    if (!items.length) {
      errEl.textContent = 'Please select at least one item.';
      errEl.style.display = 'block';
      return;
    }
    errEl.style.display = 'none';
    btn.disabled = true;
    btn.textContent = 'ADDING…';
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description); });
      window.location.href = '/cart';
    })
    .catch(function (err) {
      errEl.textContent = err.message || 'Something went wrong — please try again.';
      errEl.style.display = 'block';
      btn.disabled = false;
      btn.textContent = 'Add Selected to Cart';
    });
  });

  recalc();
})();
